<mg-ui-loading-container [isLoading]="isLoading">
    <mg-summary-card-wrapper *ngIf="deal$ | async as deal">
        <mg-summary-card *ngIf="deal.options" title="Configuration" i18n-title="@@deal.summary.title-configuration">
            <mg-summary-card-column *ngIf="deal.modelName" label="Model" i18n-label="@@deal.summary.label-model">
                {{ deal.modelName }}
            </mg-summary-card-column>
            <ng-container *ngFor="let option of carOptions">
                <mg-summary-card-column
                    *ngIf="option.value"
                    [label]="{ optionName: option.key, key: 'title' } | optionTranslation | async"
                >
                    {{ option.value }}
                </mg-summary-card-column>
            </ng-container>
            <mg-summary-card-column
                *ngIf="deal.optionsDescription"
                [label]="{ optionName: 'optionsDescription', key: 'title' } | optionTranslation | async"
            >
                {{ deal.optionsDescription }}
            </mg-summary-card-column>
        </mg-summary-card>

        <mg-summary-card title="Contract" i18n-title="@@deal.summary.title-contract">
            <mg-summary-card-column
                *ngIf="deal.pricing && deal.pricing.pricePerMonthExVAT"
                label="Price per month ex. VAT"
                i18n-label="@@deal.summary.label-price-per-month-ex-vat"
            >
                {{ deal.pricing.pricePerMonthExVAT | tenantCurrency }}
            </mg-summary-card-column>
            <mg-summary-card-column
                *ngIf="deal.pricing && deal.pricing.pricePerMonthIncVAT"
                label="Price per month incl. VAT"
                i18n-label="@@deal.summary.label-price-per-month-incl-vat"
            >
                {{ deal.pricing.pricePerMonthIncVAT | tenantCurrency }}
            </mg-summary-card-column>
            <mg-summary-card-column
                *ngIf="deal.pricing && deal.pricing.fiscalValue"
                label="Fiscal value"
                i18n-label="@@deal.summary.label-fiscal-value"
            >
                {{ deal.pricing.fiscalValue | tenantCurrency }}
            </mg-summary-card-column>
            <ng-container *ngFor="let option of contractOptions">
                <mg-summary-card-column
                    *ngIf="option.value"
                    [label]="{ optionName: option.key, key: 'title' } | optionTranslation | async"
                >
                    <ng-container *ngIf="option.key === 'downpayment'">
                        {{ option.value | tenantCurrency }}
                    </ng-container>
                    <ng-container *ngIf="option.key === 'mileage'">
                        {{ option.value | number }}
                    </ng-container>
                    <ng-container *ngIf="option.key === 'duration'" i18n="@@deal.summary.value-duration"
                        >{{ option.value }} months</ng-container
                    >
                    <ng-container *ngIf="!['downpayment', 'duration', 'mileage'].includes(option.key)">
                        {{ option.value }}
                    </ng-container>
                </mg-summary-card-column>
            </ng-container>
            <mg-summary-card-column
                *ngIf="deal.referralCode && deal.referralProgram && deal.referralProgram.name"
                label="Referral code *"
                i18n-label="@@deal.summary.label-referral-code.with-asterix-at-end"
            >
                {{ deal.referralCode }}
            </mg-summary-card-column>
            <mg-summary-card-column
                *ngIf="hasReferalProgram && withAdjustableReferral && !deal.referralCode"
                label="Referral code"
                i18n-label="@@deal.summary.label-referral-code"
                class="deal-summary__referral-box"
            >
                <input
                    type="text"
                    [formControl]="referralInput"
                    id="referral-code-input"
                    (keydown.enter)="submitReferralCode()"
                />
                <button
                    (click)="submitReferralCode()"
                    (keydown.enter)="submitReferralCode()"
                    i18n="@@deal.summary.referral-code.add-button"
                >
                    Add
                </button>
                <span *ngIf="isReferralCodeInvalid" i18n="@@deal.summary.referral-code.error-message"
                    >We can't find this referral code in our database, please try again.</span
                >
            </mg-summary-card-column>
            <div
                *ngIf="deal.referralCode && deal.referralProgram && deal.referralProgram.name"
                class="referral-sentence"
            >
                <span>*</span>
                <span i18n="@@deal.summary.referral-code.disclaimer"
                    >The benefits of the referral code have already been applied to the shown contract details.</span
                >
            </div>
        </mg-summary-card>

        <mg-summary-card
            *ngIf="!hideCompanyAndDriver && deal.lessee && deal.lessee.chamberOfCommerceNr"
            title="Company details"
            i18n-title="@@deal.summary.title-company"
        >
            <mg-summary-card-column
                *ngIf="deal.lessee.name"
                [span]="2"
                label="Name"
                i18n-label="@@deal.summary.label-company-name"
            >
                {{ deal.lessee.name }}
            </mg-summary-card-column>
            <mg-summary-card-column
                *ngIf="deal.lessee.chamberOfCommerceNr"
                [span]="2"
                label="Chamber of commerce number"
                i18n-label="@@deal.summary.label-chamber-of-commerce-nr"
            >
                {{ deal.lessee.chamberOfCommerceNr }}
            </mg-summary-card-column>
            <mg-summary-card-column
                *ngIf="
                    deal.lessee.postalAddress && (deal.lessee.postalAddress.street || deal.lessee.postalAddress.city)
                "
                [span]="2"
                label="Address"
                i18n-label="@@deal.summary.label-company-address"
            >
                {{ deal.lessee.postalAddress.street }} {{ deal.lessee.postalAddress.houseNumber }}
                {{ deal.lessee.postalAddress.houseNumberSuffix }}<br />
                {{ deal.lessee.postalAddress.zipcode }}<br />
                {{ deal.lessee.postalAddress.city }}
            </mg-summary-card-column>
        </mg-summary-card>

        <mg-summary-card
            *ngIf="
                !hideCompanyAndDriver &&
                deal.driver &&
                ((deal.driver.firstName && deal.driver.lastName) || deal.driver.emailAddress)
            "
            title="Driver details"
            i18n-title="@@deal.summary.title-driver"
        >
            <mg-summary-card-column
                *ngIf="deal.driver.firstName && deal.driver.lastName"
                [span]="2"
                label="Name"
                i18n-label="@@deal.summary.label-driver-name"
            >
                {{
                    deal.driver.firstName +
                        (deal.driver.lastNamePrefix ? ' ' + deal.driver.lastNamePrefix : '') +
                        ' ' +
                        deal.driver.lastName
                }}
            </mg-summary-card-column>
            <mg-summary-card-column
                *ngIf="deal.driver.emailAddress"
                class="summary-card__email-field"
                [span]="2"
                label="E-mail address"
                i18n-label="@@deal.summary.label-driver-email"
            >
                {{ deal.driver.emailAddress }}
            </mg-summary-card-column>
        </mg-summary-card>

        <mg-summary-card
            *ngIf="deal.remarks"
            title="Additional information"
            i18n-title="@@deal.summary.title-additional-info"
        >
            <mg-summary-card-column [span]="2" label="Remarks" i18n-label="@@deal.summary.label-remarks">
                {{ deal.remarks }}
            </mg-summary-card-column>
        </mg-summary-card>
    </mg-summary-card-wrapper>
</mg-ui-loading-container>
